<script>
export default {
    data() {
        return {

        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {

    }
}
</script>

<template>
    <div>
        TEST SCENE
    </div>
</template>

<style lang='scss' scoped>

</style>